import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { COLORS } from '../../styles/theme';
import CircularProgressBar from './CircularProgressBar';

import { ExtensionControl } from './ExtensionControl';

const StyledButtonPrimary = styled(Button)(() => ({
  color: COLORS.WHITE,
  backgroundColor: COLORS.PRIMARY_BLUE,
  minWidth: '90px',
  '&:hover': {
    backgroundColor: COLORS.PRIMARY_BLUE,
  },
}));

const StyledContent = styled('div')(() => ({
  minHeight: '140px',
}));

export interface ExtensionProps {
  data: any;
  onExtensionChanged?: (extn: string) => Promise<boolean>;
  locationKey?: string;
}

export const Extension = ({
  data,
  onExtensionChanged,
  locationKey,
}: ExtensionProps) => {
  const [showProgress, setShowProgress] = useState<boolean>(false);
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);

  const [props, setProps] = useState<any>({
    extension: data.extension,
    isvalid: data.extension ? true : false,
  });

  const handleSaveExtension = async () => {
    setFormSubmitted(true);
    if (props.isvalid && props.extension && onExtensionChanged) {
      setShowProgress(true);
      await onExtensionChanged(props.extension);
      setShowProgress(false);
      setFormSubmitted(false);
    }
  };
  const validator = (valid: boolean, extnVal: string) => {
    setProps({
      extension: extnVal,
      isvalid: valid,
    });
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    handleSaveExtension();
  };

  const tooltiplErrorMessage = () => {
    let message: string;
    if (!props.isvalid && !props.extension) {
      message = 'Extension is required';
    } else if (!props.isvalid && props.extension) {
      message = 'Check For errors';
    } else {
      message = '';
    }
    return message;
  };

  return (
    <form onSubmit={handleSubmit}>
      <div
        className={`${formSubmitted ? 'formSubmitted' : ''} ${
          props.isvalid ? 'isvalid' : 'notvalid'
        }`}
      >
        <Grid container justifyContent="flex-start" spacing={1}>
          <Grid item sm={7}>
            <StyledContent>
              <ExtensionControl
                validator={validator}
                extensionData={data}
                locationKey={locationKey}
              />
            </StyledContent>
          </Grid>
          <Grid item sm={9}>
            <div style={{ textAlign: 'right' }}>
              <Tooltip title={tooltiplErrorMessage()} arrow placement="top">
                <span>
                  <StyledButtonPrimary
                    variant="contained"
                    data-testid="saveButton"
                    disabled={!props.isvalid}
                    onClick={handleSaveExtension}
                  >
                    Save
                    {showProgress && (
                      <div className="MuiProgressOverlay">
                        <CircularProgressBar />
                      </div>
                    )}
                  </StyledButtonPrimary>
                </span>
              </Tooltip>
            </div>
          </Grid>
        </Grid>
      </div>
    </form>
  );
};
